import { defineMessages } from '@jutro/locale';

export default defineMessages({
    partnerCarriers: {
        id: 'ml.gateway.views.MLPartnerCarrierPopup.Partner Carriers',
        defaultMessage: 'Partner Carriers'
    },
    auto: {
        id: 'ml.gateway.views.MLPartnerCarrierPopup.Auto',
        defaultMessage: 'Auto'
    },
    home: {
        id: 'ml.gateway.views.MLPartnerCarrierPopup.Home',
        defaultMessage: 'Home'
    },
    other: {
        id: 'ml.gateway.views.MLPartnerCarrierPopup.Other',
        defaultMessage: 'Other'
    },
    partnerCarriersQuoted: {
        id: 'ml.gateway.views.MLPartnerCarrierPopup.Partner Carrier(s) Quoted',
        defaultMessage: 'Partner Carrier(s) Quoted'
    },
    partnerCarriersSelect: {
        id: 'ml.gateway.views.MLPartnerCarrierPopup.Select all that apply:',
        defaultMessage: 'Select all that apply:'
    },
    partnerCarriersBound: {
        id: 'ml.gateway.views.MLPartnerCarrierPopup.Partner Carrier(s) Bound',
        defaultMessage: 'Partner Carrier(s) Bound'
    },
    partnerCarriersBoundSelect: {
        id: 'ml.gateway.views.MLPartnerCarrierPopup.Bound application with:',
        defaultMessage: 'Bound application with:'
    },
    save: {
        id: 'ml.gateway.views.MLPartnerCarrierPopup.SAVE',
        defaultMessage: 'SAVE'
    },
    noChangesNeeded: {
        id: 'ml.gateway.views.MLPartnerCarrierPopup.NO CHANGES NEEDED',
        defaultMessage: 'NO CHANGES NEEDED'
    }
});
